import * as React from "react";
import { SVGProps } from "react";

const Monolith = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 153 364" {...props}>
    <path d="m21 52.2 74.8 42.9c3.1 1.7 5 5 5 8.6v141.8c0 .4-.2.9-.6 1.1l-81.1 46c-.6.3-1.3.1-1.7-.5-.1-.2-.2-.4-.2-.6l.1-237.1c0-1.3 1.1-2.4 2.4-2.4.5-.1.9 0 1.3.2zM17.4 43c-1.8-1-4-.4-5 1.4-.3.6-.5 1.2-.5 1.8l-.4 248.4c0 1.8.9 3.4 2.5 4.3l86.8 49.8c1.8 1 4 .4 5-1.4.3-.6.5-1.2.5-1.8V101.1c0-4.4-2.4-8.5-6.2-10.7L17.4 43zm136.3 27.3v262.3c0 4.4-2.4 8.5-6.2 10.7l-34.7 19.8c-3.8 2.2-8.5 2.2-12.3 0L6.2 308.6C2.4 306.4 0 302.4 0 298V29.1c0-4.5 2.5-8.7 6.5-10.8L37.6 1.5c3.8-2 8.4-2 12.1.2l97.9 58c3.8 2.2 6.1 6.2 6.1 10.6z" />
  </svg>
);

export default Monolith;
